import img1 from "../images/rentcar1.jpeg";
import img2 from "../images/rentcar2.jpeg";
import img3 from "../images/rentcar3.jpeg";
import img4 from "../images/rentcar4.jpeg";
import img5 from "../images/rentcar5.jpeg";
import img6 from "../images/rentcar6.jpeg";
import img7 from "../images/rentcar7.jpeg";
import img8 from "../images/rentcar8.jpeg";
import SectionHeading from "./ui/SectionHeading";
import Reveal from "./ui/Reveal";

const images = [img1, img2, img3, img4, img5, img6, img7, img8];

const CarRent = () => {
  return (
    <section id="carrent" className="section-pad bg-[#eef5ea]">
      <SectionHeading
        eyebrow="Travel in Comfort"
        title="Ziyrat & Car Rental"
        subtitle="Comfortable, well-maintained vehicles and guided Ziyarat across the holy cities."
      />
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {images.map((src, index) => (
          <Reveal key={index} delay={index * 0.05}>
            <div className="group overflow-hidden rounded-xl shadow-soft transition-all duration-300 hover:-translate-y-1">
              <img
                src={src}
                alt={`Rental vehicle ${index + 1}`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default CarRent;
